import axios from 'axios';

// Base URLs driven by environment; fallback to nginx paths when behind reverse proxy
const API_HOST = process.env.REACT_APP_API_URL || '/api';
const PREDICT_BASE = process.env.REACT_APP_PREDICT_URL || '/app';

const SPEECH_API_BASE = API_HOST;
// This helper will send audio, language, and context to your backend speech endpoint
export async function sendVoiceToSpeechBot(blob, { language = "en", context = "", voice = "female" } = {}) {
  const formData = new FormData();
  formData.append("file", blob, "speech.ogg"); // OGG is common for MediaRecorder in Chrome
  formData.append("language", language);
  formData.append("context", context);
  formData.append("voice", voice); // female or male
  const res = await axios.post(`${SPEECH_API_BASE}/speak`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  // Normalize various backend shapes to a consistent object
  // Expected final shape: { response: string, audio_base64?: string, context?: string }
  const body = res.data;
  if (body && typeof body === 'object') {
    // FastAPI returns { status_code, data } on success
    if (body.status_code && body.status_code !== 200) {
      // Return an error-like object so caller can show a useful message
      return { response: body.message || "Service unavailable", audio_base64: null };
    }
    if (body.data && typeof body.data === 'object') {
      return body.data;
    }
  }
  return body;
}

const DB_API_BASE = API_HOST;

// const DB_API_BASE = 'http://localhost:8000';

export async function signupUser(details) {
  const body = {
    type: "signup",
    user_details: {
      name: details.name,
      display_name: details.display_name || details.name,
      password: details.password,
      age: details.age,
      gender: details.gender,
      role: details.role,
      info: ""
    }
  };

  // POST to /entry endpoint
  const res = await axios.post(`${DB_API_BASE}/entry`, body);
  return res.data;
}

export async function loginUser(details) {
  const body = {
    type: "login",
    user_details: {
      name: details.name,
      password: details.password,
      age: "",
      gender: "",
      role: "",
      info: ""

    }
  };
  const res = await axios.post(`${DB_API_BASE}/entry`, body);
  return res.data;
}
const DASHBOARD_API = `${API_HOST}/dashboard`;

const REPORT_API = `${API_HOST}/report`;

export async function fetchDashboardData({ user_id, type, current_date }) {
  return axios.post(DASHBOARD_API, { user_id, type, current_date });
}


// Save a single analysis result for daily tracking

export async function saveDailyReport({ user_id, date, emotions, meta }) {

  // emotions: { surprise, fear, sad, angry, disgust, happy }

  // meta: any extra fields (e.g., duration, source)

  return axios.post(REPORT_API, { user_id, date, emotions, meta });

}




// Doctor-specific APIs

export async function doctorListPatients(doctor_id) {

  const res = await axios.get(`${API_HOST}/doctor/patients`, { params: { doctor_id } });

  return res.data; // { status_code, data }

}



export async function doctorStartSession(doctor_patient_id, duration_seconds) {

  const res = await axios.post(`${API_HOST}/doctor/sessions/start`, { doctor_patient_id, duration_seconds });

  return res.data;

}



export async function doctorSaveEmotions({ doctor_patient_id, session_id, joy, stress, sadness, anger, burnout_score, doctor_assessment }) {

  const res = await axios.post(`${API_HOST}/doctor/sessions/emotions`, {

    doctor_patient_id,

    session_id,

    joy,

    stress,

    sadness,

    anger,

    burnout_score,

    doctor_assessment,

  });

  return res.data;

}



export async function doctorAddNote(session_id, note_text) {

  const res = await axios.post(`${API_HOST}/doctor/sessions/notes`, { session_id, note_text });

  return res.data;

}



export async function doctorListSessions(doctor_patient_id) {

  const res = await axios.get(`${API_HOST}/doctor/sessions`, { params: { doctor_patient_id } });

  return res.data; // { status_code, data }

}

// List appointments for a doctor
export async function doctorListAppointments(doctor_id) {
  const res = await axios.get(`${API_HOST}/doctor/appointments`, { params: { doctor_id } });
  return res.data; // { status_code, data }
}

export async function doctorDeleteAppointment(appointment_id, doctor_id) {
  const res = await axios.delete(`${API_HOST}/doctor/appointments/${appointment_id}`, { params: { doctor_id } });
  return res.data; // { status_code, message }
}


// Consult (Individual -> Doctor)

export async function consultListDoctors() {

  const res = await axios.get(`${API_HOST}/consult/doctors`);

  return res.data; // { status_code, data: [{user_id, user_name}] }

}



export async function consultCreateAppointment({ doctor_id, outpatient_user_id, date, time, purpose, duration_minutes, notes, age, address, contact, patient_name }) {

  const res = await axios.post(`${API_HOST}/consult/appointments`, {

    doctor_id, outpatient_user_id, date, time, purpose, duration_minutes, notes, age, address, contact, patient_name

  });

  return res.data; // { status_code, data: {id} }

}

export async function doctorListSessionNotes(session_id) {

  const res = await axios.get(`${API_HOST}/doctor/sessions/${session_id}/notes`);

  return res.data; // { status_code, data }

}



// Doctor patient management APIs

export async function doctorCreatePatient(doctor_id, name, age, address, contact, last_session, next_session, status) {

  const res = await axios.post(`${API_HOST}/doctor/patients`, {

    doctor_id, name, age, address, contact, last_session, next_session, status

  });

  return res.data; // { status_code, data }

}



export async function doctorCreateAppointment(doctor_id, patient_id, date, time, purpose, duration_minutes, notes) {

  const res = await axios.post(`${API_HOST}/doctor/appointments`, {

    doctor_id, patient_id, date, time, purpose, duration_minutes, notes

  });

  return res.data; // { status_code, data }

}



export async function doctorDeletePatient(patient_id) {

  const res = await axios.delete(`${API_HOST}/doctor/patients/${patient_id}`);

  return res.data; // { status_code, data }

}



export async function doctorUpdatePatient(patient_id, name, age, address, contact, last_session, next_session, status) {

  const res = await axios.put(`${API_HOST}/doctor/patients/${patient_id}`, {

    name, age, address, contact, last_session, next_session, status

  });

  return res.data; // { status_code, data }

}






// === Delete user from local database ===   frontend dev 19-07
export async function deleteUserById(user_id, user_name) {
  // const res = await axios.delete(`http://localhost:8000/user/${user_id}`);
  // const res = await axios.delete(`https://app.neurolonic.com/api/user/${user_id}`);
  // If user_id is not an integer, fetch it using user_name
  let intUserId = user_id;
  if (isNaN(Number(user_id)) && user_name) {
    const res = await fetch(`${API_HOST}/user/details?user_name=${encodeURIComponent(user_name)}`);

    const data = await res.json();

    if (data && data.data && data.data.user_id) {

      intUserId = data.data.user_id;

    }

  }

  const res = await axios.delete(`${API_HOST}/user/${intUserId}`);

  return res.data;

}

// === Update user profile details ===
export async function updateUserProfile(userId, updates) {
  const res = await axios.put(`${API_HOST}/user/${userId}`, updates);
  return res.data;
}


// Delete a specific report by ID

export async function deleteReport(user_id, report_id) {

  return axios.delete(`${API_HOST}/report/${report_id}`).then(r => r.data);

}

// Endpoint base URLs

const CONVERT_API = `${API_HOST}/convert`;

const PREDICT_API = `${PREDICT_BASE}/predict`;
// 1. Convert (audio -> WAV)
export async function convertToWav(file) {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(CONVERT_API, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// 2. Predict (WAV -> result)
export async function predictWithWavBlob(wavBlob, options = {}) {

  const fd = new FormData();

  fd.append("file", wavBlob, "audio.wav");



  const maxAttempts = 3; // 1 try + 2 retries

  const baseDelayMs = 800; // backoff base

  let lastError;



  for (let attempt = 1; attempt <= maxAttempts; attempt++) {

    try {
      const response = await axios.post(PREDICT_API, fd, {

        headers: { "Content-Type": "multipart/form-data" },

        timeout: 30000,

        signal: options.signal,

      });

      return response;

    } catch (err) {

      lastError = err;

      const status = err?.response?.status;

      const isTimeout = err?.code === 'ECONNABORTED';

      const isNetwork = !err?.response;

      const retriable = isTimeout || isNetwork || (status >= 500 && status < 600);

      if (retriable && attempt < maxAttempts) {

        const delay = baseDelayMs * attempt; // simple linear backoff

        await new Promise((r) => setTimeout(r, delay));

        continue;

      }

      throw err;

    }

  }

  throw lastError;

}
// PayPal Payment API

export async function createPayPalPayment(userId, amount) {

  try {

    const response = await axios.get(`${API_HOST}/payment/paypal`, {

      params: {

        user_id: userId,

        amount: amount

      }

    });

    return response.data;

  } catch (error) {

    console.error('PayPal payment creation error:', error);

    throw error;

  }

}

// === Hospital Dashboard APIs ===

export async function hospitalListDoctors(hospital_id) {
  const res = await axios.get(`${API_HOST}/hospital/doctors`, { params: { hospital_id } });
  return res.data; // { status_code, data }
}

export async function hospitalGetAllPatients(hospital_id) {
  const res = await axios.get(`${API_HOST}/hospital/patients`, { params: { hospital_id } });
  return res.data; // { status_code, data }
}

export async function hospitalCreateDoctor({ hospital_id, name, email, phone, age, gender, display_name, role_specialization }) {
  const res = await axios.post(`${API_HOST}/hospital/doctors`, {
    hospital_id, name, email, phone, age, gender, display_name, role_specialization
  });
  return res.data; // { status_code, data, message }
}

export async function hospitalCreatePatient({ hospital_id, doctor_id, name, age, address, contact }) {
  const res = await axios.post(`${API_HOST}/hospital/patients`, {
    hospital_id, doctor_id, name, age, address, contact
  });
  return res.data; // { status_code, data, message }
}

export async function hospitalCreateAppointment({ hospital_id, doctor_id, patient_id, date, time, purpose, duration_minutes, notes }) {
  const res = await axios.post(`${API_HOST}/hospital/appointments`, {
    hospital_id, doctor_id, patient_id, date, time, purpose, duration_minutes, notes
  });
  return res.data; // { status_code, data, message }
}

export async function hospitalGetAllAppointments(hospital_id) {
  const res = await axios.get(`${API_HOST}/hospital/appointments`, { params: { hospital_id } });
  return res.data; // { status_code, data }
}

export async function hospitalGetAllSessions(hospital_id) {
  const res = await axios.get(`${API_HOST}/hospital/sessions`, { params: { hospital_id } });
  return res.data; // { status_code, data }
}

export async function hospitalGetDoctorPatients(hospital_id, doctor_id) {
  const res = await axios.get(`${API_HOST}/hospital/doctors/${doctor_id}/patients`, { params: { hospital_id } });
  return res.data; // { status_code, data }
}

export async function hospitalUpdatePatientDoctor(hospital_id, patient_id, doctor_id) {
  const res = await axios.put(`${API_HOST}/hospital/patients/${patient_id}`, {
    hospital_id,
    doctor_id
  });
  return res.data; // { status_code, message }
}

export async function hospitalUpdateDoctor(hospital_id, doctor_id, { name, phone, age, gender, display_name, role_specialization }) {
  const res = await axios.put(`${API_HOST}/hospital/doctors/${doctor_id}`, {
    name, phone, age, gender, display_name, role_specialization
  }, { params: { hospital_id } });
  return res.data; // { status_code, message }
}

export async function hospitalDeleteDoctor(hospital_id, doctor_id) {
  const res = await axios.delete(`${API_HOST}/hospital/doctors/${doctor_id}`, { params: { hospital_id } });
  return res.data; // { status_code, message }
}

export async function hospitalUpdatePatient(hospital_id, patient_id, { name, age, address, contact, doctor_id }) {
  const res = await axios.put(`${API_HOST}/hospital/patients/${patient_id}/full`, {
    name, age, address, contact, doctor_id
  }, { params: { hospital_id } });
  return res.data; // { status_code, message }
}

export async function hospitalDeletePatient(hospital_id, patient_id) {
  const res = await axios.delete(`${API_HOST}/hospital/patients/${patient_id}`, { params: { hospital_id } });
  return res.data; // { status_code, message }
}

// === Corporate Well-being Dashboard APIs ===

// Department Management
export async function corporateCreateDepartment(name, created_by = null) {
  const params = created_by ? { created_by } : {};
  const res = await axios.post(`${API_HOST}/corporate/departments`, { name }, { params });
  return res.data; // { status_code, data }
}

export async function corporateListDepartments(created_by = null) {
  const params = created_by ? { created_by } : {};
  const res = await axios.get(`${API_HOST}/corporate/departments`, { params });
  return res.data; // { status_code, data }
}

export async function corporateDeleteDepartment(department_id) {
  const res = await axios.delete(`${API_HOST}/corporate/departments/${department_id}`);
  return res.data; // { status_code, message }
}

// Staff Management
export async function corporateCreateStaff({ name, email, department_id, role }, created_by = null) {
  const params = created_by ? { created_by } : {};
  const body = { name, email, department_id };
  if (role !== undefined && role !== null) body.role = role;
  const res = await axios.post(`${API_HOST}/corporate/staff`, body, { params });
  return res.data; // { status_code, data }
}

export async function corporateListStaffRoles(created_by = null) {
  const params = created_by ? { created_by } : {};
  const res = await axios.get(`${API_HOST}/corporate/staff/roles`, { params });
  return res.data; // { status_code, data: string[] }
}

export async function corporateDeleteStaff(staff_id) {
  const res = await axios.delete(`${API_HOST}/corporate/staff/${staff_id}`);
  return res.data; // { status_code, message }
}

// Session Management
export async function corporateCreateSession({ staff_id, session_date, duration, audio_urls }) {
  const res = await axios.post(`${API_HOST}/corporate/sessions`, {
    staff_id, session_date, duration, audio_urls
  });
  return res.data; // { status_code, data }
}

export async function corporateSaveEmotionDetails({
  staff_id, session_id, emotion_score, motivation_score,
  burnout_score, engagement_score, stress_score, wellbeing_score, emotion_data
}) {
  const res = await axios.post(`${API_HOST}/corporate/sessions/emotions`, {
    staff_id, session_id, emotion_score, motivation_score,
    burnout_score, engagement_score, stress_score, wellbeing_score, emotion_data
  });
  return res.data; // { status_code, data }
}

export async function corporateGetStaffSessions(staff_id, limit = 50) {
  const res = await axios.get(`${API_HOST}/corporate/staff/${staff_id}/sessions`, { params: { limit } });
  return res.data; // { status_code, data }
}

// Dashboard Analytics
export async function corporateGetDashboardAnalytics(created_by = null, department_id = null) {
  const params = {};
  if (created_by) params.created_by = created_by;
  if (department_id) params.department_id = department_id;
  const res = await axios.get(`${API_HOST}/corporate/dashboard/analytics`, { params });
  return res.data; // { status_code, data: { staff, departments } }
}

